import React from 'react';

export enum ParagraphType {
    paragraph = "PARAGRAPH",
    orderedList = "ORDERED_LIST",
    unorderedList = "UNORDERED_LIST",
}

export type ParagraphContentType = {
    subTitle: React.ReactNode;
    type: ParagraphType;
    subHeading?: React.ReactNode;
    listHeading?: React.ReactNode;
    content: React.ReactNode | React.ReactNode[];
}

export const privacyPolicy = {
    title: null,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>This document (“Privacy Policy”) sets out the policies and practices of Jigsaw Financial Technology Private Limited (“Merito” or “we” or “us” or “our”) in collecting, processing, storing, or transferring personal information, business information, usage information and other information received by Merito from you (“You”). When you are acting on behalf of a partnership, company, trust, legal entity or any other juristic person, references to “you” shall mean and include such entity.</>,
                <br />,
                <>You consent to Merito collecting, receiving, storing, using, dealing with, handling, managing, processing, providing access to, sharing, disclosing and analysing information shared by you in the manner set forth in this Privacy Policy. By accessing the application/website, using the services or by otherwise providing any information on the application/website, you will be deemed to have read, understood and agreed to the terms and conditions outlined in the Privacy Policy and agree to be bound by the Privacy Policy</>,
                <br />,
                <>This Privacy Policy has been published inter alia in compliance with the provisions of the Information Technology Act, 2000 and the rules and regulations made thereunder (including, but not limited to: (i) The Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011; and (ii) The Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021) and other applicable privacy laws to the extent that they apply to Merito’s data processing and business operations <b>(“Data Privacy Laws”).</b></>
            ]
        }

    ]
}

export const definitions = {
    title: <>Information We Collect</>,
    paragraph: [
        {
            subTitle: <>Business Information:</>,
            type: ParagraphType.paragraph,
            content: <>This would be information about your products, sales data, payment transactions etc., as collected by Merito from Your usage of Merito’s services, for providing the services availed by you from Merito such as sales reports, analytics, dashboard etc.</>
        },
        {
            subTitle: <>Personal Information:</>,
            type: ParagraphType.paragraph,
            // listHeading: <>For the purposes of this Privacy Policy:</>,
            content: [
                <>
                    Personal information means information that, by itself or in combination, can identify You i.e. a brand/business owner or their employees, directors or operators such as their name, email address, phone number, and any additional information which is relevant to such person, director or operator Merito only collects, stores and processes Personal Information of Your employees, directors or operators who are using the Merito platform for availing its services and does not collect personal information of Your customers.
                </>
            ]
        },
        {
            subTitle: <>Usage Information:</>,
            type: ParagraphType.paragraph,
            content: <>We may collect information about your interactions with Merito, such as the features you use, the websites and apps you authenticate with, your preferences for such usage and other diagnostic data.</>
        },
        {
            subTitle: <>Device and Log Information:</>,
            type: ParagraphType.paragraph,
            content: <>When you access Merito’s services, we may collect certain information about your device, such as your device type, operating system, IP address, and browser type. We may also gather log information, including details about your interactions with our app, timestamps, and system activity.</>
        },
        {
            subTitle: <>Cookies and Similar Technologies:</>,
            type: ParagraphType.paragraph,
            content: <>We may use cookies, web beacons, and similar technologies to collect information about your usage patterns, enhance your experience, and improve our services. You have the option to disable cookies through your browser settings, but please note that this may affect the functionality of Merito.</>
        },
    ]
}

export const informationWeCollect = {
    title: <>How We Use Your Information</>,
    paragraph: [
        {
            subTitle: <>Providing and Personalizing Services:</>,
            type: ParagraphType.paragraph,
            // listHeading: <>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</>,
            content: [
                <>We use your Business Information and Personal Information to provide you with the services availed by you on Merito, this may include, identity verification, preparing reports, insights and analysis, providing customer support, billing and invoicing for the services, and providing access to the services.</>
            ]
        },
        {
            subTitle: <>Communication:</>,
            type: ParagraphType.paragraph,
            content: [
                <>We may use your Business Information and Personal Information to communicate with you about important updates, service-related announcements, new features, special offers, general information about other goods, services and events which we offer or any new offerings and/or to otherwise personalise the use of the services. We may also send you promotional materials and exclusive offers that enhance your Merito experience.</>
            ]
        },
        {
            subTitle: <>Personalization and Recommendations:</>,
            // subHeading: null,
            type: ParagraphType.paragraph,
            // listHeading: <>The Company may use Personal Data for the following purposes:</>,
            content: [
                <>
                    We may utilize your Usage Information to personalize your Merito experience, tailoring content and features to align with your preferences. By analyzing your usage patterns and preferences, we can offer recommendations and suggestions that enhance your productivity and convenience.
                </>
            ]
        },
        {
            subTitle: <>Service Improvement:</>,
            type: ParagraphType.paragraph,
            // listHeading: <>We may share Your personal information in the following situations:</>,
            content: [
                <>Your Usage Information helps us improve and optimize Merito and we use aggregated data and usage patterns, determining the effectiveness of our promotional campaign and to evaluate and improve our services, insights that allow us to enhance our services, security, and user experience.</>
            ]
        },
        {
            subTitle: <>Fraud Detection and Security:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    We process your information to detect and prevent fraud, security breaches, or any misuse of Merito.
                </>
            ]
        },
        {
            subTitle: <>Legal Compliance:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    We may process your Usage Data, as required by applicable laws, regulations, or legal proceedings. This includes complying with legal obligations, responding to lawful requests, and cooperating with law enforcement authorities.
                </>
            ]
        }
    ]
}

export const storageOfYourInformation = {
    title: <>Storage Of Your Information</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    Your information which is in the possession and control of Merito is stored in accordance with the applicable laws. Storage and transfer of such information is carried out in compliance with all applicable laws, including without limitation, Data Privacy Laws. You acknowledge that transacting over the internet has inherent risks which can only be avoided by you following reasonable security practices, such as not revealing such information to any other person and informing the customer care of Merito about any suspicious activity or where your information has/may have been compromised.
                </>
            ]
        }
    ]
}

export const confidentiality = {
    title: <>Confidentiality Of Business Information</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    Your information which is in the possession and control of Merito is stored in accordance with the applicable laws. Storage and transfer of such information is carried out in compliance with all applicable laws, including without limitation, Data Privacy Laws. You acknowledge that transacting over the internet has inherent risks which can only be avoided by you following reasonable security practices, such as not revealing such information to any other person and informing the customer care of Merito about any suspicious activity or where your information has/may have been compromised.
                </>
            ]
        }
    ]
}

export const sharingInformation = {
    title: <>Sharing Your Information</>,
    paragraph: [
        {
            subTitle: <>Third-Party Service Providers: </>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    To provide our services effectively, we may engage trusted third-party service providers like SMS service provider, payment gateway providers, marketplaces etc., who assist us in collecting and transmitting Business Information and Personal Information as well as, delivering, facilitating and maintaining our services. These service providers can only access your Business Information and Personal Information, as specifically consented by you in writing, to the extent necessary to perform their services.
                </>

            ]
        },
        {
            subTitle: <>Integrated Websites and Apps:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    When you choose to authenticate with integrated websites and apps through Merito, we may securely share your authenticated details (such as your name, email, or phone number) as necessary to facilitate the authentication process or receiving any services from such integrated websites and apps. Please note that the privacy practices of these websites and apps are governed by their respective privacy policies, and we encourage you to review them before proceeding.
                </>
            ]
        },
        {
            subTitle: <>Business Transfers:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    In the event of a merger, acquisition, or sale of all or a portion of our assets, your Business Information and Personal Information may be transferred as part of the transaction. We will notify you via prominent notice and seek your consent if required by applicable laws.
                </>
            ]
        },
        {
            subTitle: <>Consent and Preferences:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    We will not share your Business Information and Personal Information with any third parties for their marketing purposes or in any other manner except with your consent.
                </>
            ]
        }
    ]
}

export const dataTransfers = {
    title: <>Data Transfers</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    Merito’s services can be used globally, which means that your Personal Information may be transferred to and processed in countries other than your own. These countries may have different data protection laws than your jurisdiction.
                </>,
                <>
                    Regardless of where your information is transferred, we take appropriate safeguards to ensure the security and confidentiality of your personal information and ensure that the security requirements of such persons is no less stringent than the measures used by us. These safeguards would include requirements mandated by applicable laws. Your consent to this Privacy Policy followed by your submission of such information represents your agreement to such transfer.
                </>
            ]
        }
    ]
}

export const rightsAndChoices = {
    title: <>Your Rights and Choices</>,
    paragraph: [
        {
            subTitle: <>Access and Control</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    You have the right to access, correct, update, or delete your Personal Information held by Merito. You can review and modify your information as provided by Merito.
                </>
            ]
        },
        {
            subTitle: <>Data Portability:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    You have the right to request a copy of your Personal Information in a structured, commonly used, and machine-readable format. This enables you to transfer your data to another service provider if desired. Please note that certain legal limitations or technical constraints may apply to data portability requests.
                </>
            ]
        },
        {
            subTitle: <>Consent Withdrawal:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    You have the right to withdraw your consent to the processing of your Personal Information at any time. If you withdraw your consent, it will not affect the lawfulness of any processing that occurred prior to the withdrawal and to the extent such information must be maintained under laws.
                </>
            ]
        },
        {
            subTitle: <>Communication Preferences:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    You have the option to manage your communication preferences, including opting out of promotional communications, newsletters, and non-essential notifications.
                </>
            ]
        },
        {
            subTitle: <>Right to Lodge a Complaint:</>,
            type: ParagraphType.paragraph,
            content: [
                <>
                    If you believe that Merito has not adequately addressed your privacy concerns, you have the right to write to us your grievances at the contact details given below.
                </>
            ]
        }
    ]
}

export const childrensPrivacy = {
    title: <>Children's Privacy</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    Merito is not intended for use by individuals under the age of 18 (or the equivalent minimum age as defined by applicable data protection laws). We do not knowingly collect or process Personal Information from children without appropriate parental consent. If we become aware that we have collected Personal Information from a child without parental consent, we will take immediate steps to delete such information from our systems.
                </>
            ]
        }
    ]
}

export const dataSecurity = {
    title: <>Data Security</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    We take data security seriously and have implemented comprehensive measures as mentioned above to protect your Personal Information and Business Information from unauthorized access, use, or disclosure. These measures include encryption, firewalls, secure protocols, access controls, and ongoing security assessments.
                </>,
                <>
                    While we strive to maintain the highest level of data security, please be aware that no method of transmission over the internet or electronic storage is completely secure. Therefore, we cannot guarantee absolute security, and you should take appropriate precautions to protect your own information.
                </>
            ]
        }
    ]
}

export const retentionOfInfo = {
    title: <>Retention of information</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    We retain your Business Information and Personal Information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by applicable law. The retention period may vary depending on the nature of the information and the purpose for which it was collected.
                </>
            ]
        }
    ]
}



export const linkWebsites = {
    title: <>Links to Other Websites</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
                </>,
                <>
                    We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
                </>
            ]
        }
    ]
}

export const changesToPrivacyPolicy = {
    title: <>Updates to the Privacy Policy</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            listHeading: null,
            content: [
                <>
                    We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or industry standards. We will notify you of any changes by prominently posting a notice within Merito or by other means as required under applicable laws. Provided that apart from such publication, Merito shall be under no obligation to inform or intimate you of any such change, modification, addition or deletion.
                </>,
                <>
                    We encourage you to review this Privacy Policy periodically to stay informed about how we collect, use, and protect your Personal Information and Business Information. Your continued use of Merito after the effective date of any changes signifies your acceptance of the updated Privacy Policy.
                </>,
            ]
        },
    ]
}



export const contactUs = {
    title: <>Contact Us</>,
    paragraph: [
        {
            subTitle: null,
            subHeading: null,
            listHeading: <>If you have any questions, concerns, or inquiries regarding this Privacy Policy please contact us. We are here to assist you and address any privacy-related issues you may have. If you have any grievances or any questions, you can reach us at the following contact details:</>,
            type: ParagraphType.unorderedList,
            content: [
                <>
                    <b>Grievance Officer:</b> [•]
                </>,
                <>
                    <b>Address</b>: 13-A, Floor-5, 1, Kamana CHS, Raobahadur SK Bole Road, Dadar, Mumbai – 400028 (India)
                </>,
                <>
                    <b>Email:</b> <a href='mailto:helpdesk@clickmerito.com'>
                        helpdesk@clickmerito.com
                    </a>
                </>,

            ]
        },
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    We value your trust and appreciate your decision to use Merito. We will continue to uphold the highest standards of data privacy and security as we strive to deliver a seamless and trustworthy user experience.
                </>
            ]
        }
    ]
}


export const governingByLaw = {
    title: <>Governing Law and Jurisdiction</>,
    paragraph: [
        {
            subTitle: null,
            type: ParagraphType.paragraph,
            content: [
                <>
                    This Privacy Policy will be governed by and construed in accordance with the laws of India and subjected to the exclusive jurisdiction of courts of Mumbai.
                </>
            ]
        }
    ]
}



